import {cs}               from "@Common/react/chain-services";
import {Static2}          from "@Common/react/static-2";
import {itemEditor, ui}   from "@Common/ui-components/heavy/item-options/modules/expo-types/expo-types";
import {ErrorHighlighter} from "@Common/ui-components/light/error-highlighter";
import {scrollIntoView}   from "@Common/ui-components/light/scroll-into-view";

import {DeliveryOptions} from "./ui/delivery-options";

export const quantityModules = ({}) => [
    {
        load: ({quantity2, paperPrices, paperPrice, variationsPricing}, rootNext) => cs(
            ["eh", (_, next) => ErrorHighlighter({next})],
            ["domRef", (_, next) => Static2({next})],
            ({eh, domRef}) => rootNext(quantity2 && (() => {
                return {
                    itemEditor: {
                        $name: "quantity",

                        errorsHandling: {
                            highlightErrors: () => {
                                eh.start();
                                scrollIntoView(domRef.get());
                            },
                        },

                        valid: !!(paperPrice || variationsPricing?.matchedTier),
                    },
                    ui: ({className}) => (paperPrices || variationsPricing) && (
                        DeliveryOptions({
                            state: quantity2.state,
                            paperPrices: variationsPricing?.tiers ?? paperPrices,
                            paperPrice: variationsPricing?.tiers ? variationsPricing.matchedTier : paperPrice,
                            eh, domRef,
                            className,
                        })
                    ),
                };
            })()),
        ),
        requires: ["quantity2", "paperPrices", "paperPrice"],
        requiresOptional: ["variationsPricing"],
        expo: [itemEditor, ui("quantity")],
    },
];
